(function () {
  angular.module("akitabox.desktop.document.list", [
    "akitabox.core.services.document",
    "akitabox.core.services.filter",
    "akitabox.ui.dialogs.document",
    "akitabox.desktop.components.filterBar",
    "akitabox.desktop.components.filterBarManager",
  ]);
})();
